import { has } from 'lodash-es'

import { EMPTY_STRING } from '../../../constants/common'
import { DATE_FILTER_TYPES } from '../../../constants/filter'
import { getDateEndParam, getDateStartParam } from '../../../utils/filter'

export function getTag(
  { name, type },
  filterOptions,
  relatedFilters,
  onSetDateRange
) {
  const isDateType = DATE_FILTER_TYPES.includes(type)

  let startKeyName = getDateStartParam(name)

  let endKeyName = getDateEndParam(name)

  if (
    (isDateType && has(filterOptions, startKeyName)) ||
    has(filterOptions, endKeyName)
  ) {
    const startDate = filterOptions[startKeyName]?.label || EMPTY_STRING
    let endDate = filterOptions[endKeyName]?.label || EMPTY_STRING

    const prefix = startDate ? EMPTY_STRING : '...'
    const suffix = endDate ? EMPTY_STRING : '...'

    let divider = EMPTY_STRING

    if (startDate === endDate) {
      endDate = EMPTY_STRING
    } else {
      divider = ' - '
    }

    return {
      getText: () => `${prefix}${startDate}${divider}${endDate}${suffix}`,
      id: `${type}-${name}`,
      onClick: () => onSetDateRange(startKeyName, null, endKeyName, null, type),
    }
  }

  const relatedName = relatedFilters[name]

  if (!relatedName) {
    return null
  }

  startKeyName = getDateStartParam(relatedName)

  endKeyName = getDateEndParam(relatedName)

  if (has(filterOptions, startKeyName) || has(filterOptions, endKeyName)) {
    const startDate = filterOptions[startKeyName]?.label || EMPTY_STRING
    let endDate = filterOptions[endKeyName]?.label || EMPTY_STRING

    const prefix = startDate ? EMPTY_STRING : '...'
    const suffix = endDate ? EMPTY_STRING : '...'

    let divider = EMPTY_STRING

    if (startDate === endDate) {
      endDate = EMPTY_STRING
    } else {
      divider = ' - '
    }

    return {
      getText: () => `${prefix}${startDate}${divider}${endDate}${suffix}`,
      id: `${type}-${name}`,
      onClick: () => onSetDateRange(startKeyName, null, endKeyName, null, type),
    }
  }

  return null
}
